import { render, staticRenderFns } from "./DeleteProductDialog.vue?vue&type=template&id=00f4f73a&scoped=true&lang=pug&"
import script from "./DeleteProductDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteProductDialog.vue?vue&type=script&lang=js&"
import style0 from "./DeleteProductDialog.vue?vue&type=style&index=0&id=00f4f73a&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f4f73a",
  null
  
)

export default component.exports